import { trackClientEvent } from 'analytics/analytics'

export type UserReviewStayAnalyticsAction =
  | 'review_entry_cta_clicked'
  | 'review_modal_opened'
  | 'review_stay_selected'
  | 'review_viewed'
  | 'review_edited'

export function trackUserReviewStayEvent(action: UserReviewStayAnalyticsAction) {
  trackClientEvent({
    subject: 'user_review',
    action,
    category: 'review',
    type: 'interaction',
  })
}
